import Vue from "vue"
import KeyCode from "../key-code"
import uniqueId from "lodash/uniqueId"

const PopupManager = {
  zIndex: (Vue.prototype.$amumu || {}).zIndex || 1000,
  popups: {},
  get nextZIndex() {
    return this.zIndex++
  },

  register(instance) {
    const popupId = (instance.popupId = uniqueId("popup-id-"))
    if (popupId && instance) {
      this.popups[popupId] = {
        popupId,
        instance,
      }
    }
  },
  unregister(instance) {
    delete this.popups[instance.popupId]
  },
  getPopup(id) {
    return this.popups[id]
  },
  modalStack: [],

  close(instance) {
    const modalStack = this.modalStack
    if (modalStack.length > 0) {
      const topPopup = this.getTopPopup()
      if (topPopup && topPopup.popupId === instance.popupId) {
        modalStack.pop()

        if (!topPopup.instance.getZIndex()) {
          this.zIndex--
        }
      }
    }
  },

  open(instance) {
    this.modalStack.push({
      popupId: instance.popupId,
    })
    instance.setZIndex(this.nextZIndex)
  },

  getTopPopup() {
    if (Vue.prototype.$isServer) {
      return
    }

    if (this.modalStack.length > 0) {
      const topPopup = this.modalStack[this.modalStack.length - 1]
      if (!topPopup) {
        return
      }

      return this.getPopup(topPopup.popupId)
    }
  },
}

if (!Vue.prototype.$isServer) {
  window.addEventListener("keydown", event => {
    if (event.keyCode === KeyCode.ESC) {
      const topPopup = PopupManager.getTopPopup()

      if (topPopup && topPopup.instance.escClosable) {
        // close
        topPopup.instance.close("esc")
      }
    }
  })
}

export default PopupManager
